export default {
  title: '{{company}} heeft je afhaaltijd gewijzigd',
  new_time_label: 'Nieuwe tijd',
};
